import {INVE_FIELDS} from '@/constants/inve';
import {Booleans} from '@/model/src/values/dv-boolean';
import {Condition, Event} from '../types';
import {Conditions} from './conditions';
import {and, not, or} from './conditions/utils';

export const hasPrefilledBankAccounts = Conditions.fields.isFilled(INVE_FIELDS.INVE34_bankAccountBankNo.atIndex(0));

export const isPrefilledClient = Conditions.fields.eq(INVE_FIELDS.INVE_IsPrefilledClient, Booleans.True);

export const canSelectBankAccountFromPrefilledClient = and(isPrefilledClient, hasPrefilledBankAccounts);

export const isDocumentCreatedFromPrefilledInvestor = Conditions.fields.isFilled(INVE_FIELDS.INVE0_investorNo);

export const isNotPrefilledInvestor = not(isPrefilledClient) satisfies Condition;

const prefilledClientContractNumberMatchesInput = or(
  // We check empty fields so that an empty prefilled value does not cause a false positive on manual edit
  Conditions.fields.eq('A8', ''),
  Conditions.fields.eq(INVE_FIELDS.INVE16_accountNo, ''),
  Conditions.fields.eq('A8', {$ref: INVE_FIELDS.INVE16_accountNo}),
);

const prefilledClientSocialSecurityNumberMatchesInput = or(
  // We check empty fields so that an empty prefilled value does not cause a false positive on manual edit
  Conditions.fields.eq('A4', ''),
  Conditions.fields.eq(INVE_FIELDS.INVE4_socialSecurityNumber, ''),
  Conditions.fields.eq('A4', {$ref: INVE_FIELDS.INVE4_socialSecurityNumber}),
);

export const prefilledClientMatchesInput = and(
  prefilledClientSocialSecurityNumberMatchesInput,
  prefilledClientContractNumberMatchesInput,
);

export const setINVEIsPrefilledClientEvent: Event = {
  action: {
    type: 'set',
    field: INVE_FIELDS.INVE_IsPrefilledClient,
    value: {
      $switch: [
        {
          $case: [prefilledClientMatchesInput],
          $then: {
            $ref: Booleans.True,
          },
        },
        {
          $default: {
            $ref: Booleans.False,
          },
        },
      ],
    },
  },
  conditions: [isDocumentCreatedFromPrefilledInvestor],
};
